import { modalUserSearchStore } from '@/store'
import { ModalUserSearchInterface } from '@/store/ModalUserSearchStore'

export class ModalUserSearchService {
  public open(params: ModalUserSearchInterface) {
    modalUserSearchStore.open(params)
  }

  public close() {
    modalUserSearchStore.close()
  }
}
